import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import CSWDriverTipInput from './csw-driven-input';
import { useIsLocalDeliveryServiceSelected } from '../../hooks/use-is-local-delivery-service-selected';
import { useEnableLocalDeliveryDriverTip } from '../../../feature-flags/hooks/use-enable-local-delivery-driver-tip';

import style from '../style.module.css';
import messages from './messages';

const DriverTipWithLabel = ({ fulfillmentPlanId }) => {
  const isDriverTipEnabled = useEnableLocalDeliveryDriverTip();
  const isPickupServiceSelectedInCSW = useIsLocalDeliveryServiceSelected();
  return (
    isDriverTipEnabled &&
    isPickupServiceSelectedInCSW && (
      <React.Fragment>
        <label className={style.label}>
          <FormattedMessage {...messages.driverTip} />
        </label>
        <CSWDriverTipInput fulfillmentPlanId={fulfillmentPlanId} />
        <div />
      </React.Fragment>
    )
  );
};

DriverTipWithLabel.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export default DriverTipWithLabel;
